module.exports = __webpack_public_path__ + "img/cat1.966ee82f.png";